const _ = require('./status/enum');

module.exports = [
  _.AUTHORIZATION_DECLINED,
  _.AUTHORIZATION_EXPIRED,
  _.AUTHORIZATION_RENEWED,
  _.AUTHORIZATION_FAILED, // TODO : remove when not used
  _.AUTHORIZATION_REQUEST_FAILED,
  _.AUTHORIZATION_REQUEST_EXPIRED,
  _.AUTHORIZATION_REQUESTED,
  _.AUTHORIZATION_SUCCESSFUL,
];
